const {Backbone} = require('backboneAdapter');
import NavBarView from 'js/views/navbar.view';
import NotificationsView from 'js/views/notifications.view';
require('l10n');

    console.info("Starting Notification Center Router");
    export default Backbone.Router.extend({
        routes : {
            "" : "defaultRoute"
        },
        initialize : function () {
            this.navbar = new NavBarView();
        },
        defaultRoute : function () {
            this.notificationsView = new NotificationsView();
        }
    });
